import { render, staticRenderFns } from "./LeaveAdmin.vue?vue&type=template&id=00a85b6c&scoped=true"
import script from "./LeaveAdmin.ts?vue&type=script&lang=ts&external"
export * from "./LeaveAdmin.ts?vue&type=script&lang=ts&external"
import style0 from "./LeaveAdmin.vue?vue&type=style&index=0&id=00a85b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a85b6c",
  null
  
)

export default component.exports